import { Link, useLocation } from 'react-router-dom'
import type { ReactNode } from 'react'
import { supabase } from '../lib/supabase'
import { useAuth } from '../hooks/useAuth'

export function Header() {
  const { pathname } = useLocation()
  const { user } = useAuth()
  const interno = pathname.startsWith('/interno')

  return (
    <header className="border-b border-pfa-navy/10 bg-white">
      <div className="mx-auto flex max-w-5xl items-center justify-between px-4 py-4">
        <Link to={interno ? '/interno' : '/'} className="flex items-center gap-2.5">
          <img src="/brand/logo-horizontal.png" alt="Paula Farias Advocacia" className="h-8 w-auto" />
          <span className="hidden rounded bg-pfa-coral/10 px-2 py-0.5 text-[11px] font-semibold uppercase tracking-wider text-pfa-coral sm:inline">
            {interno ? 'Equipe' : 'Resolve'}
          </span>
        </Link>

        {interno ? (
          user && (
            <nav className="flex items-center gap-4 text-sm">
              <Link to="/interno" className="text-pfa-slate hover:text-pfa-navy">Fila de casos</Link>
              <Link to="/interno/producao" className="text-pfa-slate hover:text-pfa-navy">Produção</Link>
              <Link to="/interno/metricas" className="text-pfa-slate hover:text-pfa-navy">Métricas</Link>
              <button
                onClick={() => supabase.auth.signOut()}
                className="font-medium text-pfa-slate hover:text-pfa-coral"
              >
                Sair
              </button>
            </nav>
          )
        ) : (
          <nav className="flex items-center gap-4 text-sm">
            <Link to="/triagem" className="text-pfa-slate hover:text-pfa-navy">Avaliar meu caso</Link>
            <Link to="/painel" className="text-pfa-slate hover:text-pfa-navy">Meu caso</Link>
          </nav>
        )}
      </div>
    </header>
  )
}

export function Footer() {
  return (
    <footer className="mt-16 bg-pfa-navy">
      <div className="mx-auto max-w-5xl px-4 py-10 text-xs leading-relaxed text-white/70">
        <img src="/brand/logo-horizontal-branco.png" alt="Paula Farias Advocacia" className="h-7 w-auto" />
        <p className="mt-4">Responsável técnica: Paula Cristina Farias — OAB/SC 41.026, OAB/SP 415.541 e OAB/RJ 232.838.</p>
        <p className="mt-2 max-w-2xl">
          Conteúdo informativo. Não constitui promessa ou garantia de resultado. Estimativas apresentadas são
          ilustrativas. Cada caso é analisado individualmente por um advogado especialista em Direito Imobiliário da
          nossa equipe.
        </p>
      </div>
    </footer>
  )
}

export function Page({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-full flex-col">
      <Header />
      <main className="mx-auto w-full max-w-5xl flex-1 px-4 py-8">{children}</main>
      <Footer />
    </div>
  )
}

export function Stepper({ step }: { step: number }) {
  const steps = ['Triagem', 'Proposta', 'Contratação', 'Documentos', 'Acompanhamento']
  return (
    <ol className="mb-8 flex flex-wrap gap-2 text-xs">
      {steps.map((s, i) => (
        <li
          key={s}
          className={`rounded-full px-3 py-1 ${
            i <= step ? 'bg-pfa-navy text-white' : 'bg-pfa-navy/10 text-pfa-slate'
          }`}
        >
          {i + 1}. {s}
        </li>
      ))}
    </ol>
  )
}
